import React, {useState, useEffect, useRef} from 'react';
import performanceService from '../../services/data/performance.service';
import { Toast } from 'primereact/toast';
import 'moment/locale/pt-br'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import moment from 'moment';

export default function CareerPerformancePDIDetail(props) {

    const toast = useRef(null);
    const stepDetail = props.stepDetail
    const [stepDetailData, setStepDetailData] = useState(null)

    useEffect(() => {
        if (stepDetail) {
            getStepDetail()
        }
    }, [stepDetail])

    function getStepDetail() {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: stepDetail
        }
        performanceService.developmentPlanDetail(data).then((response) => {
            setStepDetailData(response.sessions?.[0])
        })
    }

    function actionPlanType(value) {
        switch (value) {
            case 'CF':
                return 'Curso/Formação'
            case 'PR':
                return 'Projeto'
            case 'TR':
                return 'Trabalho'
            case 'TA':
                return 'Tarefa'
            case 'OU':
                return 'Outro'
        default:
            break;
    }
    }

    function getActionPlanStatus(value) {
        switch (value) {
            case 'NI':
                return 'Não Iniciado'
            case 'FA':
                return '1-25%'
            case 'FB':
                return '25-50%'
            case 'FC':
                return '50-75%'
            case 'FD':
                return '75-99%'
            case 'CS':
                return 'Completado'
        default:
            break;
    }
    }


    return (
        <>
        <Toast ref={toast} position="top-right" />

        {
            stepDetailData ?
            <>
            <div className=''>
            {
                stepDetailData.questions.map((item, index) =>
                <div key={index} className='border rounded mb-2'>
                    <div className='p-3'>
                        <span className='fw-bold'>{index+1}.</span>
                        <span className='fs-6 fw-normal' dangerouslySetInnerHTML={{ __html: item.question }}></span>
                    </div>
                    {
                        item.actionPlans && item.actionPlans.length > 0 ?
                        <div className=''>
                            <table className='table border-top'>
                                <thead className='table-light'>
                                    <tr>
                                        <th colSpan={2}>Planos de Ação</th>
                                        <th className='text-center'>Tipo</th>
                                        <th className='text-center'>Status</th>
                                        <th className='text-center'>Última Atualização</th>
                                    </tr>
                                </thead>
                                <tbody>
                            {
                                item.actionPlans.map((plan, idx) =>
                                <tr key={idx}>
                                    <td width='10'>
                                        <span className='fw-bold'>{idx+1}.</span>
                                    </td>
                                    <td className=''>
                                        <span dangerouslySetInnerHTML={{__html: plan.action}}></span>
                                    </td>
                                    <td className='text-center'>
                                        {actionPlanType(plan.actionType)}
                                    </td>
                                    <td className='text-center'>
                                        {
                                            plan.actionPlanStatus && plan.actionPlanStatus.length > 0 ?
                                            <>
                                            {
                                                plan.actionPlanStatus[0].status === 'CS' ?
                                                <>
                                                <FontAwesomeIcon className='text-green' icon={solid('circle-check')} /> {getActionPlanStatus(plan.actionPlanStatus[0].status)}
                                                </>
                                                :
                                                <>{getActionPlanStatus(plan.actionPlanStatus[0].status)}</>
                                            }
                                            </>
                                            :
                                            <>
                                            <span>Não Iniciado</span>
                                            </>
                                        }
                                    </td>
                                    <td className='text-center'>
                                    {
                                            plan.actionPlanStatus && plan.actionPlanStatus.length > 0 ?
                                            <>
                                            <span>{moment(plan.actionPlanStatus[0].created).format("DD/MM/YYYY")}</span>
                                            </>
                                            :
                                            <>
                                            <span>Não Iniciado</span>
                                            </>
                                        }
                                    </td>
                                </tr>
                                )
                            }
                                </tbody>
                            </table>
                        </div>
                        : null
                    }
                </div>
                )
            }
            </div>
            </>
            : null
        }
        
        </>

    )
}